"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("../../errors");
const Rels_1 = require("../models/Rels");
const RqlHelper_1 = __importDefault(require("../utils/RqlHelper"));
const WmsRestClient_1 = __importDefault(require("../utils/WmsRestClient"));
//import Env from "@env";
class CustomersAccessor {
    constructor(wmsRestClient) {
        if (!wmsRestClient) {
            const billboardHost = process.env.WMS_BILLBOARD_HOST;
            if (!billboardHost) {
                throw new Error('WMS_BILLBOARD_HOST must be present in the process environment');
            }
            // Not required in the environment, will be used if provided
            const s3BillboardUrl = process.env.WMS_S3_BILLBOARD_URL ?? '';
            const wmsAuthBasic = process.env.WMS_AUTH_BASIC;
            if (!wmsAuthBasic) {
                throw new Error('WMS_AUTH_BASIC must be present in the process environment');
            }
            wmsRestClient = new WmsRestClient_1.default(billboardHost, s3BillboardUrl);
            wmsRestClient.wmsHost = billboardHost;
            wmsRestClient.wmsAuthBasic = wmsAuthBasic;
        }
        this._wmsRestClient = wmsRestClient;
    }
    _wmsRestClient;
    deactivatedPropSub = 'readonly.deactivated==false';
    customerIdPartialPropSub = 'readonly.CustomerId==';
    async getCustomerBriefs(tplGuid) {
        const tmpCustomerURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.CustomerSvc.CustomerBriefs);
        const customerURI = this._wmsRestClient.substituteValues(tmpCustomerURI.href, { rql: this.deactivatedPropSub });
        const result = await this._wmsRestClient.get(customerURI, tplGuid);
        return (result?.ResourceList ??
            []);
    }
    async getCustomer(tplGuid, customerId) {
        const tmpCustomerBriefURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.CustomerSvc.CustomerBriefs);
        const customerBriefURI = this._wmsRestClient.substituteValues(tmpCustomerBriefURI.href, { rql: `${this.customerIdPartialPropSub}${customerId}` });
        const briefResult = await this._wmsRestClient.get(customerBriefURI, tplGuid, 'application/hal+json');
        if (!('_embedded' in briefResult)) {
            return undefined;
        }
        const customerBrief = briefResult['_embedded']['item'][0];
        const customerLinkKey = Rels_1.Rels.CustomerSvc.Customer.Rel.toLowerCase();
        const editLink = customerBrief['_links'][customerLinkKey];
        const result = await this._wmsRestClient.get(editLink.href, tplGuid);
        result.Links = [
            {
                Href: editLink.href,
                Name: 'edit',
            },
        ];
        return result;
    }
    async updateCustomer(tplGuid, customer) {
        const links = customer.Links;
        const editLink = customer.Links?.filter((link) => link.Name == 'edit')[0];
        if (!customer.Etag) {
            throw new errors_1.QueryParameterError(errors_1.QpErrorCode.Required, ['Etag']);
        }
        try {
            const result = await this._wmsRestClient.put(editLink?.Href, customer, tplGuid);
            result.Links = links;
            return result;
        }
        catch (error) {
            if (error.response?.status == 412) {
                throw new errors_1.Errors.RecordOutOfDateError();
            }
            throw error;
        }
    }
    async getItemSummaryList(tplGuid, customerId, orderId, receiverId, skuList, getDeactivated = true) {
        const tempItemSummaryListURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.CustomerSvc.ItemSummaries);
        const pageSize = 100;
        const subValues = {
            id: `${customerId}`,
            pgsiz: `${pageSize}`,
            getdeactivated: `${getDeactivated}`,
        };
        if (orderId) {
            subValues['orderid'] = `${orderId}`;
        }
        else if (receiverId) {
            subValues['receiverid'] = `${receiverId}`;
        }
        if (skuList) {
            const encodedSkus = skuList.map((sku) => RqlHelper_1.default.EncodeSpecialCharactersForHttp(sku));
            subValues['rql'] = `sku=in=(${encodedSkus.join(',')})`;
        }
        const itemSummaryArray = [];
        let countItems = 1;
        for (let pageNum = 1; (pageNum - 1) * pageSize < countItems; pageNum++) {
            subValues['pgnum'] = `${pageNum}`;
            const itemSummaryListURI = this._wmsRestClient.substituteValues(tempItemSummaryListURI.href, subValues);
            const tempResult = await this._wmsRestClient.get(itemSummaryListURI, tplGuid);
            countItems = tempResult.TotalResults;
            itemSummaryArray.push(...tempResult.ResourceList);
        }
        return itemSummaryArray;
    }
    async getRecurringStorageCharges(tplGuid, customerId, transactionId) {
        const tempTransactionChargesURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.CustomerSvc.Charges);
        const transactionChargesURI = this._wmsRestClient.substituteValues(tempTransactionChargesURI.href, { id: `${customerId}`, tid: `${transactionId}` });
        const transactionCharges = await this._wmsRestClient.get(transactionChargesURI, tplGuid, 'application/hal+json');
        return transactionCharges;
    }
}
exports.default = CustomersAccessor;
